import {applyMiddleware, createStore, compose} from 'redux';
import thunk from 'redux-thunk'
import {createLogger} from 'redux-logger';
import reducers from './reducers';

const logger = createLogger();
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export function configureStore(initialState) {

    const middlewares = [logger];

    const store = createStore(
        reducers,
        composeEnhancers( applyMiddleware(thunk) ),
        initialState,
        applyMiddleware(...middlewares)
    );

    return store;
}

const store = configureStore()

export { store }
